/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isNil from 'lodash/isNil';

/**
 * Nahrazovač hlasitosti zařízení
 *
 * Stará se o aktualizaci master hlasitosti zařízení dle obsahu datového skladu.
 */
class ReplacerSound {
  /**
   * Vytvoří instanci.
   * @param {SoundManager} soundManager
   */
  constructor(soundManager) {
    this.soundManager = soundManager;
  }

  /**
   * Změní hlasitost zařízení dle datového skladu.
   * @param {ContentInfo} contentInfo
   * @returns {Promise.<undefined>} Vyřeší se po dokončení změny.
   */
  replace(contentInfo) {
    return new Promise((resolve) => {
      // Zjištění hodnoty hlasitosti.
      const { volume } = contentInfo.session;
      // Pokud hlasitost chybí, tak se zachová aktuálně nastavená.
      if (isNil(volume)) {
        return resolve();
      }
      // Změna hlasitosti, pokud nějaká je.
      return resolve(this.soundManager.setVolume(volume));
    });
  }
}

export default ReplacerSound;
